import React, { useContext, useEffect, useState } from "react";
import "./App.scss";
import arrow from "./assets/images/icons/arrowbnc.webp";
import arrow2 from "./assets/images/icons/arrowb.webp";
import FlexSection from "./components/flexSection";
import Footer from "./components/footer";
import AppContext from "./context/context";
import curly from "./assets/images/wavy line.webp";
import { motion, AnimatePresence } from "framer-motion";

function App() {
  const { navDark, setTopOn } = useContext(AppContext);
  useEffect(() => {
    setTopOn(false);
  }, [setTopOn]);
  const hVariant = {
    hide: {
      y: "50vw",
    },
    show: {
      y: 0,
      transition: {
        duration: 0.5,
        delay: 0,
        type: "ease",
      },
    },
    exit: {
      y: "-50vw",
      transition: {
        duration: 2,
        type: "ease",
        delay: 0,
      },
    },
  };
  // const containerVariants = {
  //   hide: {
  //     x: 0,
  //   },
  //   show: {
  //     x: 0,
  //     transition: {
  //       duration: 0.1,
  //       delay: 0,
  //     },
  //   },
  //   exit: {
  //     x: "100vw",
  //     transition: {
  //       duration: 0.1,
  //     },
  //   },
  // };
  const [flow, setFlow] = useState(0);
  const [drop, setDrop] = useState(false);
  useEffect(() => {
    const timer = setInterval(() => {
      setDrop(!drop);
      if (flow !== 2) {
        setFlow((prev) => prev + 1);
      } else {
        setFlow(0);
      }
    }, 8000);

    return () => {
      clearInterval(timer);
    };
  }, [flow, drop]);

  return (
    <>
      <section id="hero">
        <main>
          <div className="driver">
            <AnimatePresence mode="wait">
              {flow === 0 ? (
                <motion.h1
                  key={flow}
                  variants={hVariant}
                  initial="hide"
                  animate="show"
                  exit="exit"
                >
                  Hello
                  {navDark ? "." : ","}
                </motion.h1>
              ) : flow === 1 ? (
                <motion.h1
                  key={flow}
                  variants={hVariant}
                  initial="hide"
                  animate="show"
                  exit="exit"
                >
                  Bonjour
                  {navDark ? "." : ","}
                </motion.h1>
              ) : (
                <motion.h1
                  key={flow}
                  variants={hVariant}
                  initial="hide"
                  animate="show"
                  exit="exit"
                >
                  Namaste
                  {navDark ? "." : ","}
                </motion.h1>
              )}
            </AnimatePresence>
          </div>
          <p>
            I am ‘Kola, I like to make digital experiences{" "}
            <span className="curler">
              easier and simpler
              <div className="curl-holder">
                <img src={curly} alt="curly" className="rev-img" />
                <img src={curly} alt="curly rev" />
                <img src={curly} alt="curly" className="rev-img" />
                <img src={curly} alt="curly" />
              </div>
            </span>{" "}
            for people. <br />
            Currently working as a <span>Product Designer</span> at
            <span> Access Bank</span>.
          </p>
        </main>
        <a href="#flex-section">
          <AnimatePresence mode="wait">
            {!drop ? (
              <motion.img
                initial={{
                  width: "25px",
                }}
                animate={{
                  width: "20px",
                  transition: {
                    duration: 0.6,
                    ease: "easeInOut",
                    repeatType: "reverse",
                    repeat: Infinity,
                    type: "spring",
                    delay: 3,
                    when: "beforeChildren",
                    staggerChildren: 1,
                    mass: 0.4,
                    damping: 8,
                  },
                }}
                exit={{
                  width: "20px",
                  transition: {
                    duration: 0.3,
                    ease: "easeInOut",
                    repeatType: "reverse",
                    repeat: Infinity,
                    delay: 0.5,
                  },
                }}
                src={arrow}
                alt="arrow"
              />
            ) : (
              <motion.img
                src={arrow2}
                alt="arrow"
                initial={{
                  width: "25px",
                }}
                animate={{
                  width: "20px",
                  transition: {
                    duration: 0.6,
                    ease: "easeInOut",
                    repeatType: "reverse",
                    repeat: Infinity,
                    type: "spring",

                    when: "beforeChildren",
                    staggerChildren: 1,
                    mass: 0.4,
                    damping: 8,
                    delay: 0.5,
                  },
                }}
                exit={{
                  width: "20px",
                  transition: {
                    duration: 0.3,
                    ease: "easeInOut",
                    repeatType: "reverse",
                    repeat: Infinity,
                  },
                }}
              />
            )}
          </AnimatePresence>
        </a>
      </section>
      <FlexSection />
      <Footer />
    </>
  );
}

export default App;
